import { propEq } from 'ramda'
import React from 'react'

import { ACTIONS } from '../_constants/actions'
import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { SmallText, Title } from '../../../packages/kiti/components/presentation/Text'
import { usePublicToken } from './_load/PublicTokenLoader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import TabsMenu from '../../../packages/kiti/components/tabs/TabsMenu'

const ModalHeader = () => {
  const publicToken = usePublicToken()

  return (
    <>
      <Grid justify="space-between" align="center">
        <Col flex={1}>
          <SmallText size="xsmall">{ACTIONS.find(propEq('id', publicToken.action))?.name}</SmallText>
          <Title size="h5" bold>
            {publicToken.name}
          </Title>
        </Col>
      </Grid>

      <Separator weight={2} />

      <TabsMenu />
    </>
  )
}

export default ModalHeader
